import {Button, Drawer, DrawerProps, message, Space, Table} from 'antd';
import Style from './index.module.scss';
import type {ColumnsType} from 'antd/es/table';
import {useMutation, useQuery} from 'react-query';
import useModalHandler from 'Utils/Hooks/useModalHandler';
import EditMcpFunDrawer from '../EditMcpFunDrawer';
import {McpFunction} from './service';
import Operate from 'Components/ProTable/Components/Operate';
import {LinkButton} from 'Features/Buttons/LinkButton';
import DeleteConfirm from '../../../../../Components/DeleteConfirm';
import McpArgsDrawer from '../McpArgsDrawer';
import McpReturnsDrawer from '../McpReturnsDrawer';

interface Props extends DrawerProps {
    onOk: () => void;
    mcpId: string;
}

const Index = ({onOk, mcpId, ...props}: Props) => {
    const editDrawer = useModalHandler({
        component: EditMcpFunDrawer,
        type: 'drawer',
    });

    const mcpArgsDrawer = useModalHandler({
        component: McpArgsDrawer,
        type: 'drawer',
    });

    const mcpReturnsDrawer = useModalHandler({
        component: McpReturnsDrawer,
        type: 'drawer',
    });

    const getData = useQuery({
        queryKey: ['McpFunction.list', mcpId],
        queryFn: () => McpFunction.list({mcpId}),
    });

    const onDelete = useMutation({
        mutationFn: McpFunction.remove,
        onSuccess: () => {
            message.success('成功!');
            getData.refetch();
        },
    });

    function onEditOk() {
        getData.refetch();
        editDrawer.close();
    }

    const columns: ColumnsType<McpFunction.List> = [
        {
            title: '名称',
            dataIndex: 'name',
        },
        {
            title: 'url',
            dataIndex: 'url',
        },
        {
            title: '方法',
            dataIndex: 'method',
        },
        {
            title: '操作',
            fixed: 'right',
            width: 220,
            dataIndex: 'id',
            align: 'center',
            render: (value, record) => (
                <Operate>
                    <LinkButton
                        onClick={() =>
                            mcpArgsDrawer.open({
                                id: value,
                                functionId: value,
                                onOk: onEditOk,
                            })
                        }>
                        参数
                    </LinkButton>
                    <LinkButton
                        onClick={() =>
                            mcpReturnsDrawer.open({
                                id: value,
                                functionId: value,
                                onOk: onEditOk,
                            })
                        }>
                        返回值
                    </LinkButton>
                    <LinkButton
                        onClick={() =>
                            editDrawer.open({
                                id: value,
                                mcpId,
                                onOk: onEditOk,
                            })
                        }>
                        编辑
                    </LinkButton>
                    <DeleteConfirm onSuccess={() => onDelete.mutate(value)}>
                        <LinkButton>删除</LinkButton>
                    </DeleteConfirm>
                </Operate>
            ),
        },
    ];

    function Extra() {
        return (
            <Space>
                <Button
                    type="primary"
                    onClick={() =>
                        editDrawer.open({
                            mcpId,
                            onOk: onEditOk,
                        })
                    }>
                    新增
                </Button>
            </Space>
        );
    }

    return (
        <Drawer title="Mcp Function" width="90%" {...props} extra={<Extra />}>
            <div className={Style.root}>
                <Table
                    rowKey="id"
                    bordered
                    size="small"
                    columns={columns}
                    dataSource={getData.data?.data}
                    loading={getData.isLoading || onDelete.isLoading}
                    scroll={{x: 'max-content'}}
                    pagination={false}
                />

                {editDrawer.render()}
                {mcpArgsDrawer.render()}
                {mcpReturnsDrawer.render()}
            </div>
        </Drawer>
    );
};

export default Index;
